"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementValues = void 0;
/**
 * Dictionary to hold created elements
 */
class ElementValues {
    constructor() {
        this.values = {};
    }
    add(key, val) {
        var _a;
        (this.values[key] = (_a = this.values[key]) !== null && _a !== void 0 ? _a : []).push(val);
    }
    get(key) {
        var _a;
        return ((_a = this.values[key]) !== null && _a !== void 0 ? _a : []);
    }
}
exports.ElementValues = ElementValues;
